import { ICONS_INSIGHTS } from "@/const/insights-constants"
import { withInternetFacing } from "@/helpers/insights.helper"
import { InsightsCell } from "@/molecules/InsightsCell"

import type { CellProps } from "@/molecules/InsightsCell"
import type { InsightsApplicationCellProps } from "./InsightsApplicationCell.types"

export const InsightsApplicationCell = (props: CellProps & { tag?: boolean }) =>
  function InsightsApplicationCellComponent(
    values: InsightsApplicationCellProps,
    record?: { key: string }
  ) {
    return (
      <InsightsCell
        hide
        tag={props.tag}
        id={record?.key}
        items={withInternetFacing(
          [
            ICONS_INSIGHTS.publicImage,
            ICONS_INSIGHTS.ingress,
            ICONS_INSIGHTS.aiInsight
          ],
          props.internetFacingFF
        )}
        values={values}
        t={props.t}
      />
    )
  }
